import { Component, Input } from '@angular/core';
import { getFileExtension } from 'src/app/services/utils';
import { ExtensionMappings } from '../../services/constants'


@Component({
  selector: 'app-doc-icon',
  templateUrl: './doc-icon.component.html'
})
export class DocIconComponent {

  docIcon: string;

  #fileName: string;
  get fileName(): string {
    return this.#fileName;
  }
  @Input()
  set fileName(value: string) {
    if (this.#fileName !== value) {
      this.#fileName = value;
      this.load();
    }
  }

  load(): void {
    const fileExtension = getFileExtension(this.fileName.toLowerCase());
    this.docIcon = ExtensionMappings[fileExtension] ? ExtensionMappings[fileExtension] : ExtensionMappings["generic"];
  }
}



